


import Vue from "vue";
import { UserConfigService } from "@/services/user-config-service";
import { TranslateResult } from "vue-i18n";
import { CustomerService } from "@/services/customer-service";
import { SupplierService } from "@/services/supplier-service";
import { ProspectService } from "@/services/prospect-service";
import { AuthService } from "@/services/auth-service";
import { MODULE } from "@/config/modules";
import { PurchaseService } from "@/services/purchase-service";
import AppAutoBarcodeSettings from "./AutoBarcodeSettings.vue";
import { ConfirmResult } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			autoAssignProductSku: false,
			autoBarcodeSettingsOpen: false
		};
	},
	computed: {
		hasJournalModule():boolean {
			return AuthService.hasModule(MODULE.TOT_99_JOURNALEN);
		},
	},
	methods: {
		async save(){
			let settings = UserConfigService.getGeneralSettings();
			settings.AutoAssignProductSku = this.autoAssignProductSku;
			await UserConfigService.setGeneralSettings(settings);
		},
		async confrimResetNumbering(name:TranslateResult):Promise<boolean>{
			return (await this.$confirmBuilder().setWarningTitle().setMessage(this.$ct("confrim-reset-numbering", {name})).show()) == ConfirmResult.YES;
		},
		notifyResetSuccess(name:TranslateResult){
			return this.$wf.notify(this.$ct("notify-number-reset-success", {name}), "success", 3000, "check");
		},
		async resetNumberingForClients(){
			let name = this.$ct("clients");
			let confirm = await this.confrimResetNumbering(name);
			if (!confirm) return;
			await CustomerService.resetNumbering();
			this.notifyResetSuccess(name);
		},
		async resetNumberingForSuppliers(){
			let name = this.$ct("suppliers");
			let confirm = await this.confrimResetNumbering(name);
			if (!confirm) return;
			await SupplierService.resetNumbering();
			this.notifyResetSuccess(name);
		},
		async resetNumberingForProspects(){
			let name = this.$ct("prospects");
			let confirm = await this.confrimResetNumbering(name);
			if (!confirm) return;
			await ProspectService.resetNumbering();
			this.notifyResetSuccess(name);
		},
		async resetNumberingForPurchases(){
			let name = this.$ct("purchases");
			let confirm = await this.confrimResetNumbering(name);
			if (!confirm) return;
			await PurchaseService.resetNumbering(1);
			this.notifyResetSuccess(name);
		},
		openAutoBarcodeSettings(){
			this.autoBarcodeSettingsOpen = true;
		}
	},
	async mounted() {
		this.autoAssignProductSku = UserConfigService.getGeneralSettings().AutoAssignProductSku;
	},
	components: {
		AppAutoBarcodeSettings
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
